export default function trackGtmEvent(eventName: string, options: {}) {
  const gtm = useGtm()

  gtm.trackEvent({
    event: eventName,
    ...options,
  })
}
